import type {PeriodicIntersectionDomain2D} from './AbstractPeriodicIntersectionSolver';
import {
    CircleCircleIntersectionSolver,
    type CircleCircleIntersection2D,
    type CircleIntersectionDefinition2D,
} from './CircleCircleIntersectionSolver';

/**
 * 二维圆弧求交定义。
 *
 * 该定义与圆弧求解子类放在同一模块，避免周期抽象层反向依赖具体圆求解器。
 */
export interface CircularArcIntersectionDefinition2D
    extends CircleIntersectionDefinition2D, PeriodicIntersectionDomain2D {}

/**
 * 圆弧与圆的单个真实交点。
 */
export interface ArcCircleIntersection2D extends CircleCircleIntersection2D {
    /** 交点在圆弧有效域内的局部参数，范围 `[0, 1]`。 */
    arcParameter: number;
}

/**
 * 圆弧与圆的真实交点求解器。
 *
 * 父类计算两个完整支撑圆的解析交点，子类仅过滤第一个圆的圆弧有效域。
 */
export class ArcCircleIntersectionSolver extends CircleCircleIntersectionSolver {
    /**
     * 求解圆弧与圆的全部真实交点。
     *
     * @param arc 作为第一个支撑圆的圆弧定义。
     * @param circle 完整圆定义。
     * @returns 位于圆弧有效域内的真实交点。
     */
    public solveArcCircle(
        arc: CircularArcIntersectionDefinition2D,
        circle: CircleIntersectionDefinition2D,
    ): ArcCircleIntersection2D[] {
        return super.solve(arc, circle).flatMap((intersection) => {
            // 第一个圆角参数属于圆弧支撑圆，因此统一由周期域基类完成过滤和参数换算。
            const arcParameter = this.projectAngleToDomainParameter(intersection.firstCircleAngle, arc);
            return arcParameter === null
                ? []
                : [{...intersection, arcParameter}];
        });
    }
}
